<template>
    
    <div>
        <div v-if="hidePrice == false" class="col-12 row mb-1">
            <c-ancora
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                :fontSize="$root.$children[0].theme.font_size_button"
                href="#"
                @click.prevent.stop="addItemsCart()"
                padding="1.5rem 2.3rem"
                class="paction add-cart mb-1 mr-2"
            >
                <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">{{ $root.$children[0].theme.products.button.content_button_variation ? $root.$children[0].theme.products.button.content_button_variation : 'Adicionar ao carrinho' }}</span>
            </c-ancora>
            <c-ancora
                v-if="purchaseButtonVariation"
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                href="#"
                padding="1.5rem 2rem"
                :fontSize="$root.$children[0].theme.font_size_button"
                @click.prevent.stop="addItemsCart(true)"
                class="paction purchase mb-1 ml-0"
            >
                <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                    {{company_payment.finalizacao_pagamento.tipo == 'PAGAMENTO' ? (isBudgetLayout ? 'Orçar' : 'Comprar itens selecionados') : 'Orçamento'}}
                </span>
            </c-ancora>
        </div>
        <div v-if="$v.selectedProducts.$error" class="required">* Selecione um produto</div>
        <div class="col-12 pr-0 row mt-2 mb-3">
            <template v-for="linked in linked_products">
                <div
                    v-if="linked.pro_stock_site > 0 || linked.out_of_stock_unavailable == true || linked.sell_out_of_stock == true"
                    :key="linked.id"
                    :class="`
                        p-2
                        ${local == 'page' ?
                            ' col-12 col-sm-6 col-md-4 col-xl-3' :
                            ' col-12 col-sm-6 col-lg-4'}
                        `"
                >
                    <LinkedProductsEndPage
                        :item="linked"
                        :v.sync="$v"
                        :resetProdPage.sync="resetProdPage"
                        :quantitySaleVariations="item.quantity_sale_variations"
                        @updateLinkedProductEndPage="updateLinkedProductEndPage"
                    />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CAncora } from '../Styles/Button/styled'
import { requiredIf } from 'vuelidate/lib/validators'
import LinkedProductsEndPage from './LinkedProductsEndPage.vue'
import { swall } from '../../services/sweetAlert'

export default {
    name: 'ProductVariations',
    components: {
        LinkedProductsEndPage,
        'c-ancora': CAncora,
    },
    props: {
        item: {
            required: true
        },
        locale_linked_products: {
            required: true
        },
        linked_products: {
            required: true
        },
        local: {
            default: 'page'
        }
    },
    data() {
        return {
            isLoading: false,
            valLinkedProducts: false,
            resetProdPage:true,
            selectedProducts: [],
            company_payment: this.$root.$children[0].$attrs.company,
            quantity_items: 0
        }
    },
    validations: {
        selectedProducts: {
            required: requiredIf(function (val) {
                return Object.entries(this.linked_products).length > 0 && this.locale_linked_products == 1 && this.valLinkedProducts === true
            })
        }
    },
    mounted() {
        this.selectedProducts = [];
        this.checkQuantityAvailable();
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemCart",
            "ActionSetItemsCart",
            "ActionAddItemsCart",
            "setDisabledVariation"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        ...mapActions("products", [
            "setQuantityProductItemsGroup"
        ]),
        checkQuantityAvailable() {
            let totalLinkedProductsToBuy = this.linked_products
                .map(v => {
                    if (!v.sell_out_of_stock || (v.sell_out_of_stock && v.maximum_sale_quantity_variation)) {
                        return Number(v.maximum_sale_quantity_variation ?? v.pro_stock_site)
                    }
                    return 100
                })
                .reduce((acc, cur) => acc + cur, 0);

            if (totalLinkedProductsToBuy < this.item.quantity_sale_variations) {
                swall("Este produto não possui quantidade suficiente para compra! Contate-nos para mais informações.", true);
            }
        },
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 5) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000));
        },
        isInvalidSaleQuantityOfVariations() {
            this.quantity_items = 0
            this.selectedProducts.map(el => {
                this.quantity_items += Number(el.pro_qtd)
            })
            this.setQuantityProductItemsGroup(this.item.quantity_sale_variations - this.quantity_items)
            return this.quantity_items != Number(this.item.quantity_sale_variations)
        },
        async addItemsCart(data) {
            if (this.isLoading) {
                return
            }
            this.valLinkedProducts = true
            let redirect_cart = data
            this.isLoading = true
            if (this.$v.$invalid) {
                this.isLoading = false
                this.$v.$touch()
                return
            }
            if(this.activateSaleProductGroups && this.isProductGroup && this.isInvalidSaleQuantityOfVariations()) {
                this.isLoading = false
                return this.alertToast(`Selecione ${this.item.quantity_sale_variations} itens para efetuar ${this.isBudgetLayout ? 'o orçamento' : 'a compra'}`);
            }
            if(this.itemsCart?.list?.length) {
                let esgotado = this.itemsCart.list.some(el => {
                    let e = this.selectedProducts.find(e => e.pro_id == el.id)

                    if(e && !el.sell_out_of_stock) {
                        let max = el.maximum_sale_quantity && el.maximum_sale_quantity > el.pro_stock_site ? el.pro_stock_site : (el.maximum_sale_quantity ?? el.pro_stock_site)
                        let resto = Number(max) % Number(el.quantity_conversion_factor)
                        let qtdSobra = resto == 0 ? resto : Number(el.quantity_conversion_factor) - resto
                        let qtd = Number(max) - qtdSobra
                        max = qtd < Number(el.minimumQuantity) ? Number(el.minimumQuantity) : qtd

                        if(+e.pro_qtd > (+max - +el.qtd_cart)) {
                            return true
                        }
                        return false
                    }
                    return false
                })
                if(esgotado) {
                    this.isLoading = false
                    this.alertToast('Quantidade indisponível!')
                    return
                }
            }

            let formData = new FormData()
            // if(this.activateSaleProductGroups && this.isProductGroup) {
                this.selectedProducts.map(p => {
                    p.father_product = this.item.id
                    p.is_product_group = this.isProductGroup
                })
            // }
            formData.append('itemsCart', JSON.stringify(this.selectedProducts))
            await this.ActionAddItemsCart(formData)
            .then(async (resp) => {
                this.isLoading = false
                let { data } = resp

                if(this.activateSaleProductGroups && this.isProductGroup) {
                    this.quantity_items = 0
                    this.setDisabledVariation(false)
                    this.setQuantityProductItemsGroup(0)
                }

                this.ActionSetItemsCart(data)
                if(this.facebookPixel?.settings?.AddToCart == true) {
                    await fbq('track', 'AddToCart', {content_type: 'product', contents: {id: formData.pro_id, quantity: Number(formData.pro_qtd)}})
                }
                if(typeof gtag === 'function') {
                    gtag('event', 'add_to_cart', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Variações do Produto',
                        'ecommerce': {
                            'currency': 'BRL',
                            'value': this.selectedProducts
                                .reduce((total, selectedProduct) => {
                                    const cartProduct = data.list.find(cartItem => cartItem.id === selectedProduct.pro_id);
                                    return total + ((Number(cartProduct?.price_to ??cartProduct?.pro_price_site) || 0) * Number(selectedProduct.pro_qtd));
                                }, 0).toFixed(2),

                            'products': this.selectedProducts
                                .map(selectedProduct => {
                                    const cartProduct = data.list.find(cartItem => cartItem.id === selectedProduct.pro_id);
                                    return {
                                        'id': cartProduct?.api_cod_original || '',
                                        'name': cartProduct?.pro_name_site || '',
                                        'price': (cartProduct?.price_to ?? cartProduct.pro_price_site).toFixed(2),
                                        'quantity': Number(selectedProduct.pro_qtd) || 1,
                                        'discount': cartProduct?.percentage_discount || 0,
                                        'variant': cartProduct?.items_grid_abbreviaton ??
                                                    `${cartProduct?.grid_group_column_value ?? ''}${cartProduct?.grid_group_row_value ?? ''}`
                                    };
                                })
                        }
                    });

                }
                this.resetProdPage = true
                this.$v.$reset();
                this.selectedProducts.splice(0)
                $('.quantity-linked-products-end-page').each(function() {
                    $(this).val(null)
                })
                localStorage.setItem('reset', 'true')
                $('.linked-product-end-page').each(function() {
                    $(this).removeClass('active')
                })
                if(redirect_cart == true) {
                    window.location.href = this.openCartPage == true ? this.$baseUrl + 'cart' :  this.$baseUrl + 'checkout'
                    return
                }

                if(this.local == 'modal') {
                    this.$root.closeModalApp('product_modal')
                }

                this.alertToast('Produto adicionado ao carrinho com sucesso!', 'check', 'success')
            })
            .catch((error) => {
                this.isLoading = false
                this.alertToast(error?.msg ?? error)
            })
        },
        updateLinkedProductEndPage(item, qtd) {
            let index = this.selectedProducts.findIndex(el => el.pro_id == item.id)
            if(qtd == 0){
                let element = this.selectedProducts.splice(index, 1)[0]
                this.setDisabledVariation(false)
                this.setQuantityProductItemsGroup(this.quantityProductItemsGroup + element.pro_qtd)
                return
            }
            if(index >= 0) {
                this.selectedProducts[index].pro_qtd = +qtd
            } else {
                this.selectedProducts.push({
                    pro_id: item.id,
                    pro_qtd: +qtd
                })
            }
            localStorage.setItem('reset', 'false')

            if(this.activateSaleProductGroups && this.isProductGroup && (!this.isInvalidSaleQuantityOfVariations() || this.isQuantityItemsGreaterThanQuantitySaleVariations)) {
                this.setDisabledVariation(true)
            } else {
                this.setDisabledVariation(false)
            }
        },
    },
    watch: {
        item() {
            this.checkQuantityAvailable();
        }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        ...mapState("company", [
            "company",
            "facebookPixel",
            "googleAds"
        ]),
        ...mapState("products", [
            "quantityProductItemsGroup"
        ]),
        isQuantityItemsGreaterThanQuantitySaleVariations() {
            return this.quantity_items > Number(this.item.quantity_sale_variations)
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isProductGroup() {
            return this.productSettings?.is_product_group ?? false
        },
        productSettings(){
            if(this.item?.settings) {
                return JSON.parse(this.item.settings)
            }
            return null
        },
        activateSaleProductGroups() {
            return this.company?.settings?.activate_sale_product_groups ?? false
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        openCartPage() {
            return this.$root.$children[0].theme?.cart.open_cart_page ?? true
        },
        purchaseButtonVariation() {
            return this.$root.$children[0].theme?.products?.button?.purchase_button_product_variation ?? true
        },
    }
}
</script>
